import http from '@/utils/http';

export const searchRune = (parameter) => {
  return http.request({
    url: '/v1/games/rune/search',
    method: 'post',
    data: parameter
  })
}